// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.export-homologation-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 140px;
  background-color: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  gap: 20px;
}

.export-homologation-image {
  position: relative;
  width: 30%;
  order: 1;
  padding: 10px 0;
  margin-top: 0;
}

.services-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.export-homologation-text {
  width: 65%;
  order: 2;
  margin-top: -90px;
}

.export-homologation-text h1 {
  font-size: 2rem;
  color: #000;
  margin-bottom: 10px;
}

.export-homologation-text h2 {
  font-size: 1.5em !important;
  color: #555;
  margin-bottom: 15px;
  font-weight: 600;
}

div.export-homologation-text p {
  font-size: 1.2em;
  color: #555;
  margin-bottom: 20px;
}

.services-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none;
  padding: 0;
}

.services-list li {
  width: 45%;
  font-size: 0.9em;
  color: #333;
}

.export-homologation-button {
  background-color: #00c853;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 1em;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s ease;
}

.export-homologation-button:hover {
  background-color: #009624;
}

@media (max-width: 768px) {
  .export-homologation-container {
    flex-direction: column;
    align-items: center;
    text-align: left;
    gap: 20px;
  }

  .export-homologation-text {
    margin-top: -60px;
    width: 300%;
    order: 2;
  }

  .export-homologation-image {
    width: 300%;
    order: 1;
  }

  .services-list li {
    width: 100%;
  }
}

@media (min-width: 1920px) and (max-width: 1920px) {
  .export-homologation-container {
    padding: 80px;
  }

  .export-homologation-image {
    width: 20%;
  }

  .export-homologation-text {
    width: 70%;
  }

  .services-list li {
    width: 40%;
  }
}

@media (min-width: 1380px) and (max-width: 1919px) {
  .export-homologation-container {
    padding: 70px;
  }

  .export-homologation-image {
    width: 20%;
  }

  .export-homologation-text {
    width: 73%;
  }

  .services-list li {
    width: 45%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ExportHomologation/ExportHomologation.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".export-homologation-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 140px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  gap: 20px;\n}\n\n.export-homologation-image {\n  position: relative;\n  width: 30%;\n  order: 1;\n  padding: 10px 0;\n  margin-top: 0;\n}\n\n.services-image {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n.export-homologation-text {\n  width: 65%;\n  order: 2;\n  margin-top: -90px;\n}\n\n.export-homologation-text h1 {\n  font-size: 2rem;\n  color: #000;\n  margin-bottom: 10px;\n}\n\n.export-homologation-text h2 {\n  font-size: 1.5em !important;\n  color: #555;\n  margin-bottom: 15px;\n  font-weight: 600;\n}\n\ndiv.export-homologation-text p {\n  font-size: 1.2em;\n  color: #555;\n  margin-bottom: 20px;\n}\n\n.services-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  list-style: none;\n  padding: 0;\n}\n\n.services-list li {\n  width: 45%;\n  font-size: 0.9em;\n  color: #333;\n}\n\n.export-homologation-button {\n  background-color: #00c853;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 1em;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 20px;\n  transition: background-color 0.3s ease;\n}\n\n.export-homologation-button:hover {\n  background-color: #009624;\n}\n\n@media (max-width: 768px) {\n  .export-homologation-container {\n    flex-direction: column;\n    align-items: center;\n    text-align: left;\n    gap: 20px;\n  }\n\n  .export-homologation-text {\n    margin-top: -60px;\n    width: 300%;\n    order: 2;\n  }\n\n  .export-homologation-image {\n    width: 300%;\n    order: 1;\n  }\n\n  .services-list li {\n    width: 100%;\n  }\n}\n\n@media (min-width: 1920px) and (max-width: 1920px) {\n  .export-homologation-container {\n    padding: 80px;\n  }\n\n  .export-homologation-image {\n    width: 20%;\n  }\n\n  .export-homologation-text {\n    width: 70%;\n  }\n\n  .services-list li {\n    width: 40%;\n  }\n}\n\n@media (min-width: 1380px) and (max-width: 1919px) {\n  .export-homologation-container {\n    padding: 70px;\n  }\n\n  .export-homologation-image {\n    width: 20%;\n  }\n\n  .export-homologation-text {\n    width: 73%;\n  }\n\n  .services-list li {\n    width: 45%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
